export default __webpack_public_path__ + "fda326c4847b4feaf99bd77c56d83925.jpg";